import { render } from "./Natura.vue?vue&type=template&id=35144b9e&scoped=true"
import script from "./Natura.vue?vue&type=script&lang=js"
export * from "./Natura.vue?vue&type=script&lang=js"

import "./Natura.vue?vue&type=style&index=0&id=35144b9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35144b9e"]])

export default __exports__